import React from "react";
import PlanTotals from "./PlanTotals";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const PlanSummary = () => {

    const history = useHistory();

    const goToAddPlan = _ => {
        history.push("/options/plans/add");
    }

    return (
        <>
            <div>
                <Button onClick={goToAddPlan} variant="primary">Add Plan</Button>
            </div>
            <div>
                <PlanTotals />                 
            </div>        
        </>
    );
}

export default PlanSummary;